// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media(max-width:768px){.right-part[data-v-715ac073]{margin:12px!important}}@media(min-width:768px){.gradient-form[data-v-715ac073]{height:100vh!important}}@media(min-width:769px){.gradient-custom-2[data-v-715ac073]{border-top-right-radius:.3rem;border-bottom-right-radius:.3rem}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
